import { UISimulation } from '@/components/help/UISimulation';
import { SimShell } from './simShell';

const D = 1900;

// Authority sources — 4 frames: list -> suggest with AI -> checkboxes -> bulk
// add.
function ASList(): JSX.Element {
  return (
    <SimShell step={1} total={4} title="Authority sources">
      <ul className="space-y-1 text-[11px]">
        {['niaaa.nih.gov', 'pubmed.ncbi.nlm.nih.gov'].map((s) => (
          <li
            key={s}
            className="rounded border border-dash-border bg-dash-surface px-3 py-1.5 font-mono text-dash-secondary"
          >
            {s}
          </li>
        ))}
      </ul>
      <div className="mt-1.5 text-[10px] font-mono text-dash-muted">
        shared sources merge in from the platform
      </div>
    </SimShell>
  );
}

function ASSuggest(): JSX.Element {
  return (
    <SimShell step={2} total={4} title="Suggest with AI">
      <div className="rounded border border-accent/40 bg-accent/10 px-3 py-2 text-xs text-dash-secondary">
        The generator reads your site context and proposes 10–20 sources.
        <div className="mt-1.5 text-accent font-mono text-[10px] uppercase">[ Suggest with AI ]</div>
      </div>
    </SimShell>
  );
}

function ASChecks(): JSX.Element {
  return (
    <SimShell step={3} total={4} title="Pick suggestions">
      <ul className="space-y-1 text-[11px]">
        {[
          ['fda.gov', true],
          ['cochranelibrary.com', true],
          ['examplepharma.com', false],
        ].map(([s, on]) => (
          <li key={String(s)} className="flex items-center gap-2">
            <span
              className={
                'inline-block w-3 h-3 rounded-sm border ' +
                (on ? 'border-accent bg-accent/40' : 'border-dash-border')
              }
            />
            <span className="font-mono text-dash-secondary">{s}</span>
          </li>
        ))}
      </ul>
    </SimShell>
  );
}

function ASAdd(): JSX.Element {
  return (
    <SimShell step={4} total={4} title="Bulk add">
      <div className="rounded border border-success/40 bg-success/10 px-3 py-2 text-xs">
        <div className="text-dash-primary">2 new sources added.</div>
        <div className="text-[10px] font-mono uppercase text-success mt-0.5">
          de-duplicated against existing rows
        </div>
      </div>
    </SimShell>
  );
}

export function AuthoritySourcesSimulation(): JSX.Element {
  return (
    <UISimulation
      steps={[
        { frame: <ASList />, label: 'Per-site source list', duration: D },
        { frame: <ASSuggest />, label: 'Ask AI for suggestions', duration: D },
        { frame: <ASChecks />, label: 'Check the ones you trust', duration: D },
        { frame: <ASAdd />, label: 'Bulk add the selection', duration: D },
      ]}
    />
  );
}
